<div class="item-content">
    <div class="item-icon text-accent"
         *ngIf="iconClass"
         [ngClass]="iconClass"
    ></div>
    <div class="item-body">
        <ng-content></ng-content>
    </div>
</div>
